import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { SimpleModalComponent } from './simple-modal.component';
import { LightImageComponent } from '../light-image/light-image.component';
import { LightImageModule } from '../light-image/light-image.module';

@NgModule({
    declarations: [
        SimpleModalComponent,
    ],
    exports: [
        SimpleModalComponent
    ],
    imports: [
        CommonModule,
        SvgIconModule,
        LightImageModule,
    ]
})
export class SimpleModalModule { }
